'use client';

import { useEffect, useState } from 'react';
import Image, { type ImageProps } from 'next/image';

const RENDER_PATH = '/storage/v1/render/image/public/';
const OBJECT_PATH = '/storage/v1/object/public/';

/** Fällt bei fehlgeschlagener Supabase-Bildtransformation (z. B. ERR_CONNECTION_RESET
 *  bei Lastspitzen) auf die unveränderte Original-Datei zurück. */
function toRawUrl(src: string): string {
  if (!src.includes(RENDER_PATH)) return src;
  const rewritten = src.replace(RENDER_PATH, OBJECT_PATH);
  const queryIndex = rewritten.indexOf('?');
  return queryIndex === -1 ? rewritten : rewritten.slice(0, queryIndex);
}

export function ResilientImage(props: ImageProps) {
  const [src, setSrc] = useState(props.src);
  const [usedFallback, setUsedFallback] = useState(false);

  useEffect(() => {
    setSrc(props.src);
    setUsedFallback(false);
  }, [props.src]);

  return (
    <Image
      {...props}
      src={src}
      onError={() => {
        if (!usedFallback && typeof src === 'string') {
          setUsedFallback(true);
          setSrc(toRawUrl(src));
        }
      }}
    />
  );
}
